var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    !_vm.loaded && _vm.suppliers.length == 0
      ? _c(
          "div",
          { staticClass: "sidebar-loading" },
          [_c("w-progress-circular", { attrs: { small: "" } })],
          1
        )
      : _vm.suppliers.length == 0
      ? _c("div", { staticClass: "sidebar-empty" }, [
          _vm._v(_vm._s(_vm.$ct("sidebar.product-suppliers.none"))),
        ])
      : _c(
          "div",
          { staticClass: "sidebar-table-wrap" },
          [
            _c(
              "app-custom-table",
              {
                staticClass: "sidebar-table",
                attrs: { cellpadding: "0", cellspacing: "0" },
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.$ct("sidebar.product-suppliers.supplier"))
                      ),
                    ]),
                    _c("th", { staticClass: "amount" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$ct("sidebar.product-suppliers.catalog-price")
                        )
                      ),
                    ]),
                    _c("th", { staticClass: "amount" }, [
                      _vm._v(
                        _vm._s(_vm.$ct("sidebar.product-suppliers.netto-price"))
                      ),
                    ]),
                  ]),
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.suppliers, function (s) {
                    return _c(
                      "tr",
                      { key: s.ID, class: { main: s.IsMainSupplier } },
                      [
                        _c("td", [
                          _c(
                            "div",
                            { staticClass: "sidebar-supplier-name" },
                            [
                              s.IsMainSupplier
                                ? _c("w-fa", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.$ct(
                                          "sidebar.product-suppliers.main"
                                        ),
                                        expression:
                                          "$ct('sidebar.product-suppliers.main')",
                                      },
                                    ],
                                    staticClass: "sidebar-supplier-star",
                                    attrs: { icon: "star" },
                                  })
                                : _vm._e(),
                              _vm._v(" " + _vm._s(_vm.supplierName(s)) + " "),
                            ],
                            1
                          ),
                          s.SupplierCode
                            ? _c(
                                "div",
                                { staticClass: "sidebar-supplier-code" },
                                [_vm._v(_vm._s(s.SupplierCode))]
                              )
                            : _vm._e(),
                        ]),
                        _c("td", { staticClass: "amount" }, [
                          _vm._v(_vm._s(_vm.printFloat(s.CatalogPrice))),
                        ]),
                        _c("td", { staticClass: "amount" }, [
                          _c("b", [
                            _vm._v(_vm._s(_vm.printFloat(s.NettoPrice))),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }